"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestUserDetailsStats = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const moment_1 = __importDefault(require("moment"));
const userDetailsStatsQuery = (0, graphql_tag_1.default) `
query UserDetailStats($workspaceId: ID!, $userId: ID!, $referenceDate: Datetime, $splitByContractTypes: Boolean) {
  role(workspace: $workspaceId, user: $userId) {
    stats(referenceDate: $referenceDate, splitByContractTypes: $splitByContractTypes) {
      monthContractMinutes
      monthContractMinutesByContract {
        minutes
        contractType
      }
      monthPlannedMinutes
      monthPlannedMinutesByContract {
        minutes
        contractType
      }
      monthOverTimeMinutes
      monthAttendanceApproved
      balancingPeriodContractMinutes
      balancingPeriodContractMinutesByContract {
        minutes
        contractType
      }
      balancingPeriodPlannedMinutes
      balancingPeriodPlannedMinutesByContract {
        minutes
        contractType
      }
      balancingPeriodOverTimeMinutes
      yearVacationMinutes
      yearVacationRemainingMinutes
      yearVacationDays
      yearVacationRemainingDays
      yearVacationByContracts {
        minutes
        minutesRemaining
        minutesMaximum
        days
        daysRemaining
        daysMaximum
        contractType
      }
    }
  }
}`;
const requestUserDetailsStats = async ({ workspaceId, userId, referenceDate, splitByContractTypes }) => {
    const { data, errors } = await (0, apollo_1.query)(userDetailsStatsQuery, {
        variables: {
            workspaceId, userId, referenceDate: (0, moment_1.default)(referenceDate).endOf('day').toDate(), splitByContractTypes
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.role;
};
exports.requestUserDetailsStats = requestUserDetailsStats;
